import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
    Box,
    Button,
    Divider,
    Stack,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HOST_URL from "../../utils/Url";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import { usePermissionData } from "../../usePermissionData";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "../../utils/Url";
import { Chip } from "@mui/material/node";

interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}

export default function QueryUpdate() {
    const { i18n, t } = useTranslation();
    const [columns, setColumns] = useState<any>([]);
    const [rows, setRows] = useState<any>([]);
    const [editId, setEditId] = useState("-1");
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [permissionData, setPermissionData] = useState<MenuPermission>({
        isAdd: false,
        isEdit: false,
        isPrint: false,
        isDel: false,
    });
    const navigate = useNavigate();

    useEffect(() => {
        // const dataString = localStorage.getItem("userdata");
        // if (dataString) {
        //     const data = JSON.parse(dataString);
        //     if (data && data.length > 0) {
        //         const userPermissionData = data[0]?.userPermission;
        //         if (userPermissionData && userPermissionData.length > 0) {
        //             const menudata = userPermissionData[0]?.parentMenu;
        //             for (let index = 0; index < menudata.length; index++) {
        //                 const childMenudata = menudata[index]?.childMenu;
        //                 const pathrow = childMenudata.find(
        //                     (x: any) => x.path === location.pathname
        //                 );
        //                 console.log("data", pathrow);
        //                 if (pathrow) {
        //                     setPermissionData(pathrow);
        //                     getList();
        //                 }
        //             }
        //         }
        //     }
        // }

        getList();
    }, []);
    // }, [isLoading]);


    const handleSwitchChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        value: any
    ) => {
        console.log(value)
        const updatedStatus = event.target.checked ? true : false;
        const collectData = {
            id: value.id,
            queryType: value.queryType,
            queryDetail: value.queryDetail,
            status: updatedStatus,
            createdBy: value.createdBy,
            updatedBy: value.updatedBy,
            createdOn: value.createdOn,
            updatedOn: value.updatedOn,

        };
        api
            .post(`Query/AddUpdateCountryMaster`, collectData)
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                    getList();

                } else {
                    toast.error(response.data.mesg);
                }
            });
    };

    let delete_id = "";
    const accept = () => {
        const collectData = {
            id: delete_id,
        };
        console.log("collectData " + JSON.stringify(collectData));
        api
            .delete(`Query/DeleteQuery`, { data: collectData })
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                } else {
                    toast.error(response.data.mesg);
                }
                getList();
            });
    };
    const reject = () => {
        // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        toast.warn("Rejected: You have rejected", { autoClose: 3000 });
    };

    const handledeleteClick = (del_id: any) => {
        // console.log(del_id + " del_id ");
        delete_id = del_id;
        confirmDialog({
            message: "Do you want to delete this record ?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            acceptClassName: "p=-button-danger",
            accept,
            reject,
        });
    };

    const getList = () => {
        const collectData = {
            id: -1,
        };
        try {
            api
                .post(`Query/GetQuery`, collectData)
                .then((res) => {
                    console.log("result" + JSON.stringify(res.data.data));
                    const data = res.data.data;
                    const arr = data.map((item: any, index: any) => ({
                        ...item,
                        serialNo: index + 1,
                        id: item.id,

                    }));
                    setRows(arr);
                    setIsLoading(false);
                    if (data.length > 0) {
                        const columns: GridColDef[] = [
                            {
                                field: "actions",
                                headerClassName: "MuiDataGrid-colCell",
                                headerName: t("text.Action"),
                                width: 150,

                                renderCell: (params) => {
                                    console.log("Is Edit Allowed:", permissionData?.isEdit);
                                    return [
                                        <Stack
                                            spacing={1}
                                            direction="row"
                                            sx={{ alignItems: "center", marginTop: "5px" }}
                                        >
                                            {/* {permissionData?.isEdit ? ( */}
                                            <EditIcon
                                                style={{
                                                    fontSize: "20px",
                                                    color: "blue",
                                                    cursor: "pointer",
                                                }}
                                                className="cursor-pointer"
                                                onClick={() => routeChangeEdit(params.row)}
                                            />
                                            {/* ) : (
                                                ""
                                            )} */}
                                            {/* {permissionData?.isDel ? ( */}
                                            <DeleteIcon
                                                style={{
                                                    fontSize: "20px",
                                                    color: "red",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    handledeleteClick(params.row.id);
                                                }}
                                            />
                                            {/* ) : (
                                                ""
                                            )} */}

                                            <Switch
                                                // checked={(params.row.empStatus)}
                                                checked={params.row.status === true}
                                                style={{
                                                    color: params.row.status === true ? "green" : "red",
                                                }}
                                                onChange={(value: any) =>
                                                    handleSwitchChange(value, params.row)
                                                }
                                                inputProps={{
                                                    "aria-label": "Toggle Switch",
                                                }}
                                            />
                                        </Stack>,
                                    ];
                                },
                            },

                            {
                                field: "serialNo",
                                headerName: t("text.SrNo"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                                minWidth:70,
                            },
                            {
                                field: "queryType",
                                headerName: t("text.QueryType"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                                minWidth: 200
                            },

                            {
                                field: "queryDetail",
                                headerName: t("text.QueryDetail"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                                minWidth:200
                            },

                            {
                                field: "status",
                                headerName: t("text.Status"),
                                flex: 1,
                                headerClassName: "MuiDataGrid-colCell",
                                minWidth:100,
                                renderCell: (params) => [
                                    <Stack direction="row" spacing={1}>
                                        {params.row.status === true ? (
                                            <Chip
                                                label={t("Active")}
                                                color="success"
                                                style={{ fontSize: "14px" }}
                                            />
                                        ) : (
                                            <Chip
                                                label={("InActive")}
                                                color="error"
                                                style={{ fontSize: "14px" }}
                                            />
                                        )}
                                    </Stack>,
                                ],
                            },
                        ];
                        setColumns(columns as any);
                    }
                });
            // setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            // setIsLoading(false);
        }
    };
    const validationSchema = Yup.object({
        queryType: Yup.string().test(
            "required",
            "Query Type Required",
            function (value: any) {
                return value && value.trim() !== "";
            }
        ),
    });
    const [toaster, setToaster] = useState(false);
    const formik = useFormik({
        initialValues: {
            "id": -1,
            "queryType": "",
            "queryDetail": "",
            "status": true,
            "createdBy": "",
            "updatedBy": "",
            "createdOn": new Date().toISOString(),
            "updatedOn": new Date().toISOString()
        },
        validationSchema: validationSchema,
        onSubmit: async (values: any) => {
            setLoading(true);
            values.id = editId;
            // console.log("check", values);

            const response = await api.post(
                `Query/AddUpdateCountryMaster`,
                values
            );
            if (response.data.isSuccess) {
                setToaster(false);
                toast.success(response.data.mesg);
                formik.resetForm();
                getList();
                setEditId("-1");
            } else {
                setToaster(true);
                toast.error(response.data.mesg);
            }
            setLoading(false);
        },
    });

    const requiredFields = ["queryType"];


    const routeChangeEdit = (row: any) => {
        formik.setFieldValue("queryType", row.queryType);
        formik.setFieldValue("queryDetail", row.queryDetail);
        formik.setFieldValue("status", row.status);

        setEditId(row.id);
    };

    return (
        <>
            <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
                <Card
                    style={{
                        width: "100%",
                        height: "50%",
                        backgroundColor: "#E9FDEE",
                        border: ".5px solid #FF7722 ",
                        marginTop: "5px",
                    }}
                >
                    <Paper
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            "& .MuiDataGrid-colCell": {
                                backgroundColor: "#2B4593",
                                color: "#fff",
                                fontSize: 18,
                                fontWeight: 800,
                            },
                        }}
                        style={{ padding: "10px" }}
                    >
                        <ConfirmDialog />
                        <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            sx={{ padding: "20px" }}
                            align="left"
                        >
                            {t("text.QueryUpdation")}
                        </Typography>
                        <Divider />

                        <Box height={10} />
                        <Stack >

                            <form onSubmit={formik.handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <TextField
                                            id="queryType"
                                            type="text"
                                            label={
                                                <span>
                                                    {t("text.QueryType")}{" "}
                                                    {requiredFields.includes("QueryType") && (
                                                        <span
                                                            style={{
                                                                color: formik.values.queryType ? "green" : "red",
                                                            }}
                                                        >
                                                            *
                                                        </span>
                                                    )}
                                                </span>
                                            }
                                            placeholder={t("text.QueryType")}
                                            value={formik.values.queryType}
                                            size="small"
                                            name="queryType"
                                            fullWidth
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.queryType && formik.errors.queryType ? (
                                            <div style={{ color: "red", marginTop: "5px" }}>
                                                {String(formik.errors.queryType)}
                                            </div>
                                        ) : null}
                                    </Grid>

                                    <Grid item xs={12} sm={7} md={7}>
                                        <textarea
                                            id="queryDetail"
                                            placeholder={t("text.QueryDetail")}
                                            value={formik.values.queryDetail}
                                            name="queryDetail"
                                            rows={2}
                                            style={{ width: "100%" }}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={1} md={1} display="flex" justifyContent="center">
                                        <Button type="submit" variant="contained" size="small" fullWidth>
                                            {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : editId == "-1" ? t("text.save") : t("text.update")}
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={1} md={1} display="flex" justifyContent="center">
                                        <Button variant="contained" size="small" fullWidth onClick={(e: any) => {
                                            e.preventDefault();
                                            navigate("/ManageQuery/QueryType")
                                        }}>
                                            {t("text.report")}
                                        </Button>
                                    </Grid>
                                </Grid>

                            </form>


                        </Stack>
                        {isLoading ? (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <CircularProgress />
                            </div>
                        ) : (
                            <Box>
                                <br></br>
                                <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        autoHeight
                                        slots={{
                                            toolbar: GridToolbar,
                                        }}
                                        rowSpacingType="border"
                                        pagination={true}
                                        pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                                            value: size,
                                            label: `${size}`,
                                        }))}
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 5 } },
                                        }}
                                        slotProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                            },
                                        }}
                                    />
                                </div>
                            </Box>
                        )}
                    </Paper>
                </Card>
            </Grid>
            <ToastApp />
        </>
    );
}
